import React from 'react';
import cs from 'classnames';
import isEmpty from 'lodash/isEmpty';
import {connect} from 'react-redux';
import {push as changeURL} from 'react-router-redux';

import EndingPage from '~/components/pages/EndingPage';
import mapDispatch from '~/misc/mapDispatch';
import Spinner from '~/components/common/Spinner';

import css from '~/components/pages/Result/index.css';
import sharedCSS from '~/components/shared.css';
import accountPageCss from '~/components/pages/MyAccount/share.css';

class CreatePaymentResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      info: isEmpty(this.props.customerServicePaymentProcess.payInfo.data)
        ? this.props.customerServicePaymentProcess.paymentOrderInfo.data[0]
        : this.props.customerServicePaymentProcess.payInfo.data,
    };
  }
  componentWillMount() {
    const {payInfo, paymentOrderInfo} = this.props.customerServicePaymentProcess;
    if ((isEmpty(payInfo.data) && isEmpty(paymentOrderInfo.data[0]))) {
      this.props.gotoRoot();
    }
  }
  componentDidMount() {
    setTimeout(() => {
      this.props.gotoRoot();
    }, 2000);
  }
  render() {
    if (isEmpty(this.state.info)) {
      return (
        <div className={sharedCSS.viewH}>
          <div className={cs(accountPageCss.spinnerLine)}>
            <div className={cs(accountPageCss.spinner, css.marginCenter)}>
              <Spinner scalable={true}/>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={cs(sharedCSS.widewrap, 'qa-content')}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          <div className={cs(css.content)}>
            <EndingPage orderInfo={this.state.info} type='result'/>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(({routing, customerServicePaymentProcess}) => (
  {routing, customerServicePaymentProcess}
), mapDispatch({
  gotoRoot: () => changeURL('/create-account'),
}))(CreatePaymentResult);



// WEBPACK FOOTER //
// ./src/components/pages/CreateAccount/CreatePaymentResult/index.js